import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import DebugCardContainer from 'automation-ui-canvas/components/panels/debugger-panel/DebugCardContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DebugPropertyCard = ({
  property,
  value,
  token,
  isAiGenerated
}) => {
  const trackEvent = useTrackEvent();
  return /*#__PURE__*/_jsx(DebugCardContainer, {
    isAiGenerated: isAiGenerated,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        flexDirection: "row",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            display: "inline-block",
            marginInlineEnd: "100",
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "debuggerPanel.step.outputs.property"
            })
          }), /*#__PURE__*/_jsx(Text, {
            display: "inline-block",
            children: property
          })]
        }), isAiGenerated && /*#__PURE__*/_jsx(AIBadge, {})]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          display: "inline-block",
          marginInlineEnd: "100",
          typography: "heading-25",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "debuggerPanel.step.outputs.value"
          })
        }), /*#__PURE__*/_jsx(Text, {
          display: "inline-block",
          children: value
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "end",
        marginBlockStart: "100",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "small",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-1",
            name: "clipboard",
            color: EERIE
          }), /*#__PURE__*/_jsx(HelpIcon, {
            color: "icon-core-subtle",
            title: "",
            children: /*#__PURE__*/_jsx(CopyButton, {
              disabled: !token,
              size: "xs",
              use: "link",
              value: token,
              onClick: () => trackEvent(Trackables.INTERACT_WITH_SINGLE_ACTION_TESTING, {
                subAction: 'Copy token',
                value: token
              }),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "debuggerPanel.step.outputs.copyToken"
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Text, {
          as: "small",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-1",
            name: "clipboard",
            color: EERIE
          }), /*#__PURE__*/_jsx(CopyButton, {
            size: "xs",
            use: "link",
            value: value,
            onClick: () => trackEvent(Trackables.INTERACT_WITH_SINGLE_ACTION_TESTING, {
              subAction: 'Copy value',
              value
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "debuggerPanel.step.outputs.copyValue"
            })
          })]
        })]
      })]
    })
  });
};
export default DebugPropertyCard;